// TODO:
// For each Revision, turn it into a list of changes, then merge it into an overall array. return a list of changes.
// Reason being each Revision has multiple changes, as modelled on the Backend.

import React from 'react';
import { css } from '@emotion/core';
import Avatar from '@atlaskit/avatar';
import { token } from '@atlaskit/tokens';
import ReactDiffViewer from 'react-diff-viewer';

import { AVATARS_BASE_URL, DateDisplayFormats, DIRECTORY_BASE_URL } from '@/constants';
import {
  flex,
  flexDirectionColumn,
  alignItemsStart,
  spaceTopCompact,
  linkStyles,
  colors,
  extendWidth,
  flexStart,
  spaceTopComfortable,
  fontFamily,
} from '@/styles';
import { formatDateForDisplay } from '@/utils/date';

import { ChangeByRevisionList } from './types';

const localStyles = css`
  font-weight: 500;
  grid-gap: 0.38em;
  color: ${token('color.text.subtlest', colors.N500)};
`;

// Overwrite diff viewer styles that cannot be customised via api
const listStyles = css`
  table {
    ${spaceTopCompact}
    td:first-of-type, th::first-of-type {
      padding-left: 10px;
    }
  }
`;

const diffViewerOverwriteStyles = {
  wordDiff: {
    padding: '2px 0',
  },
  contentText: {
    color: token('color.text', '#172b4d'),
    fontSize: 13,
    fontFamily,
  },
  variables: {
    light: {
      removedColor: token('color.text', '#172b4d'),
      removedBackground: token('color.background.accent.red.subtlest', '#ffedeb'),
      wordRemovedBackground: token('color.background.accent.red.subtler', '#ffd2cc'),
      addedColor: token('color.text', '#172b4d'),
      addedBackground: token('color.background.accent.green.subtlest', '#dffcf0'),
      wordAddedBackground: token('color.background.accent.green.subtler', '#baf3db'),
    },
  },
};

type ChangeListProps = {
  changeList: ChangeByRevisionList;
};

const ChangeList: React.FC<ChangeListProps> = ({ changeList }) => (
  <span css={[flex, flexDirectionColumn, alignItemsStart, spaceTopCompact]}>
    {changeList.map(
      ({ author, timestamp, field, enhancedRevisionType, revision, from, to }, index) => {
        const oldValue = from || '';
        const newValue = to || '';

        return (
          <div
            key={`${revision}-${timestamp}-${author}`}
            css={[
              flex,
              flexDirectionColumn,
              extendWidth,
              listStyles,
              index > 0 ? spaceTopComfortable : '',
            ]}
          >
            <div css={[flex, flexStart, localStyles, extendWidth]}>
              <Avatar
                appearance="circle"
                src={`${AVATARS_BASE_URL}/${author}?size=small`}
                size="large"
                name={author}
              />
              <a href={`${DIRECTORY_BASE_URL}/${author}`} css={linkStyles}>
                <code>@{author}</code>
              </a>
              <span>{enhancedRevisionType}</span>
              {field && <span>the {field} at</span>}
              {!field && <span>this at</span>}
              {formatDateForDisplay(timestamp, DateDisplayFormats.TIME_WITH_NUMERIC_DATE)}
            </div>
            <ReactDiffViewer
              styles={diffViewerOverwriteStyles}
              oldValue={oldValue}
              newValue={newValue}
              splitView={false}
              hideLineNumbers
            />
          </div>
        );
      }
    )}
  </span>
);

export default React.memo(ChangeList);
